import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  JOURNEY_STEP_STATUS,
} from '../../../../services/utilityFunctions';
import Request from '../../../../services/request';
import Notifications from '../../../../services/notifications';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import withCSRF from '../../../../commonComponents/withCSRF';
import translate from '../../../../commonComponents/translate';
import SkipStepButton from '../../overall/content/components/SkipStepButton';

function TaskForm({ t, _csrf, step, onDone, onSkipStep }) {
  const isDone = step.status === JOURNEY_STEP_STATUS.DONE;
  const handleDone = () => {
    new Request(_csrf)
      .post(`/journey/step/${step._id}/done`)
      .done(() => {
        Notifications.showNotificationSuccess(
          t('success'),
          t('journey_taskDone'),
        );
        if (onDone) {
          onDone();
        }
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_taskDone');
      });
  };

  return (
    <>
      <div className="row">
        <div className={`${onSkipStep ? 'col-6' : 'col-12'} task-description`}>
          {step.description}
        </div>
        {onSkipStep && (
          <div className="col-6 skip-wrapper m-0">
            <SkipStepButton onClick={onSkipStep} />
          </div>
        )}
      </div>
      <div className="mark-done-container">
        <button
          type="button"
          disabled={isDone}
          className="btn m-btn btn-dynamic loader-button"
          onClick={handleDone}
        >
          <i
            className="la la-check"
            style={{ marginRight: '5px', marginBottom: '5px' }}
          />
          {isDone ? t('journey_isDone') : t('journey_markAsDone')}
        </button>
      </div>
    </>
  );
}

TaskForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
  onDone: PropTypes.func,
  onSkipStep: PropTypes.func,
};

TaskForm.defaultProps = {
  onDone: null,
  onSkipStep: null,
};

export default compose(translate, withCSRF)(TaskForm);
